/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcPaymentsV1IncomingWireState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_PAYMENTS_V1_INCOMING_WIRE_STATE_ENTITY_NAME = 'ixc.payments.v1.IncomingWire';
export const ixcPaymentsV1IncomingWireStateEntity = new schema.Entity<IxcPaymentsV1IncomingWireState>(IXC_PAYMENTS_V1_INCOMING_WIRE_STATE_ENTITY_NAME, {}, { idAttribute: 'wireId' });

